import Ajax from '@/lib/ajax'

export default {
  getAll() {
    return Ajax.get('/api/productManagement/categories/all')
  },
  listByKeyWord(keyWord: string) {
    return Ajax.get('/api/productManagement/categories/listByKeyWord?keyWord=' + keyWord)
  },
  deleteById(id: string | number) {
    return Ajax.delete(`/api/productManagement/categories?id=${id}`)
  },
  edit(id: string | number, editData: any) {
    let ajaxType = id ? 'put' : 'post'
    let ajaxUrl = id
      ? `/api/productManagement/categories/${id}`
      : '/api/productManagement/categories'
    return Ajax[ajaxType](ajaxUrl, editData)
  },
  getDataById(id: string | number) {
    return Ajax.get(`/api/productManagement/categories/${id}`)
  },
  getTreeData() {
    return Ajax.get('/api/productManagement/categories/tree')
  }
}
